export const CORE_ASP_COMPANIES = [
  "Make Life Better",
  "Income Max",
  "Vulnerability Registration Service",
  "Illegal Money Lending Team (Stop Loan Sharks)",
  "National Debtline",
  "PayPlan",
  "Cadent Gas",
  "YES Energy Solutions",
  "Yorkshire Water Community Trust",
];

export const isCoreAspCompany = (companyName: string): boolean => {
  if (!companyName) return false;
  const normalizedName = companyName.trim();
  if (normalizedName === "Stop Loan Sharks") {
    return true;
  }
  return CORE_ASP_COMPANIES.includes(normalizedName);
};

export const isEligibleAspCondition = (
  conditions: string[] | null,
  companyName: string,
): boolean => {
  if (!conditions || !companyName) return false;
  const normalizedName = companyName.trim();
  if (normalizedName === "Stop Loan Sharks") {
    return conditions.includes("Illegal Money Lending Team (Stop Loan Sharks)");
  }
  return conditions.includes(normalizedName);
};
